import {html, LitElement} from '@isceco/widget-library2/external/lit'
import MessageCss from './MessageCss.js'
import {getFomanticStylesheet} from '@isceco/widget-library2/assets/fomantic-icons-styles.js'

/**
 * @typedef {'success' | 'warning' | 'error'} MessageType
 */

export class Message extends LitElement {

  static get styles() {
    return [MessageCss]
  }

  static get properties() {
    return {
      type: {attribute: 'type', type: String},
      message: {attribute: 'message', type: String},
      description: {attribute: 'description', type: String},
      closable: {attribute: 'closable', type: Boolean}
    }
  }

  constructor() {
    super();

    /** @type {MessageType} */
    this.type = 'warning'
    this.message = ''
    this.description = ''
    this.closed = false
    this.closable = true
  }

  connectedCallback() {
    super.connectedCallback()

    getFomanticStylesheet()
        .then(stylesheet => {
          this.shadowRoot.adoptedStyleSheets = [...this.shadowRoot.adoptedStyleSheets, stylesheet]})
        .catch(error => {
           throw error
        })
  }

  render() {
    if (this.closed) {
      return html``;
    }
    const closeIcon = this.closable ? html`<i class="close icon" @click="${() => this.close()}"></i>` : html``;
    return html`
      <div class="container ${this.type}">
        <i class="${this._getIcon(this.type)}"></i>
        <div>
          <h3>${this.message}</h3>
          <p>${this.description}</p>
        </div>
        ${closeIcon}
      </div>
    `
  }

  _getIcon = variant => {
    if (variant === 'error') {
      return 'exclamation triangle icon'
    } else if (variant === 'success') {
      return 'check square icon'
    } else {
      return 'info circle icon'
    }
  }

  close = _ => {
    this.closed = true
    this.requestUpdate()
  }
}

customElements.define('eko-message', Message)
